import { render, staticRenderFns } from "./chemical-edit-form.html?vue&type=template&id=6bc01b74&scoped=true&"
import script from "./chemical-edit-form.js?vue&type=script&lang=js&"
export * from "./chemical-edit-form.js?vue&type=script&lang=js&"
import style0 from "./ChemicalEditForm.vue?vue&type=style&index=0&id=6bc01b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc01b74",
  null
  
)

component.options.__file = "ChemicalEditForm.vue"
export default component.exports